// NPM Imports
import React from "react";

// Components Imports

// Actions Imports

// Internal Imports

// Destructuring

export default function RevvEditorEmptyPlaceholder({
  display,
  placeholderText,
}) {
  return (
    display.show === "selected" && (
      <span
        contentEditable={false}
        className={`${
          display.direction === "vertical" ? "vertically-aligned-cfield" : ""
        }`}>
        {placeholderText}
      </span>
    )
  );
}
